/*
 * Shell layout chooser module
 */

rs.module("controls/development/theme-chooser", 
    
    ["ui/framework/theme-manager", "ui/framework/client-templates"],

    function (themeManager, clientTemplates) {

        var _selectedIndicator;

        // Initialize the control
        function initialize(containerID, themeOptionTemplateKey, themeOption, selectedIndicator) {

            var formContainer = $.js(containerID);

            for (var themeName of themeManager.themeNames) {

                // Temporary - prevent root theme from displaying in theme chooser.  Task exists to revisit and add
                // property to theme defitions for target environment to control display
                if (themeName != "root") {

                    var element = $(clientTemplates.render(themeOptionTemplateKey,
                        {
                            "themeID": themeName,
                            "themeName": themeName,
                            "isCurrent": themeManager.theme === themeName
                        }));
                }

                formContainer.append(element);
            }

            // needs to go after template has been rendered and appended because the selectedIndicator is generated by the template
            _selectedIndicator = $.js(selectedIndicator, { required: false });

            formContainer.js(themeOption, { multiple: true }).on("click enterpressed", function (e) {
                themeManager.theme = $(this).data("themeid");
                //move the selected indicator to the new theme
                $(this).prepend(_selectedIndicator);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);